import {IMessage} from "@stomp/stompjs";

export class MessageData<T> {

    public readonly data: T;

    constructor(private readonly message: IMessage) {
        this.data = JSON.parse(message.body);
    }
}